/**
 * Starter questions for the product home's empty state (Stage A): one
 * always-true opener plus up to three flow walkthroughs pulled from the
 * flows artifacts of the product's repos. Pure — the page feeds it whatever
 * artifact data has loaded; with none loaded (or none containing flows) it
 * returns [] and the chips stay hidden.
 */

/**
 * Minimal, defensive view of the flows artifact (engine-owned JSON; every
 * field optional, never throws on shape drift). Only what the starter
 * questions read.
 */
export interface FlowsArtifact {
  flows?: Record<string, { title?: string }>;
}

export const OPENER_QUESTION = 'What does this product actually do?';

const MAX_FLOW_QUESTIONS = 3;

export function starterQuestions(
  artifacts: ReadonlyArray<FlowsArtifact | undefined>,
): string[] {
  const titles: string[] = [];
  for (const artifact of artifacts) {
    if (artifact?.flows === undefined) continue;
    for (const [id, flow] of Object.entries(artifact.flows)) {
      const title = (flow.title ?? id).trim();
      if (title.length === 0 || titles.includes(title)) continue;
      titles.push(title);
    }
  }
  if (titles.length === 0 && artifacts.every((a) => a?.flows === undefined)) {
    // No artifact loaded at all: no chips (the map is still being drawn).
    return [];
  }
  return [
    OPENER_QUESTION,
    ...titles.slice(0, MAX_FLOW_QUESTIONS).map((title) => `Walk me through "${title}"`),
  ];
}
